export * from "./fireMaterial.js";
//# sourceMappingURL=index.js.map